'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessage = exports.getChannel = exports.getThreadId = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getThreadId = exports.getThreadId = (0, _getIn2.default)(_keyPaths.THREAD_ID);

var getChannel = exports.getChannel = (0, _getIn2.default)(_keyPaths.CHANNEL);

var getMessage = exports.getMessage = (0, _getIn2.default)(_keyPaths.MESSAGE);